import ManageAdPage from './ManageAdPage';
import handleManageAdPage from './handleManageAdPage';

export default handleManageAdPage(ManageAdPage);
export { default as reducer } from './ad.ducks';



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageAdPage/index.ts